import { TaskBase } from "./task_base";
import MVVMBase from "../../../../../framework/core/mvvm/mvvm_base";
import { TaskHelp } from "../task_help";
import { TaskTimeItem } from "../items/task_time_item";
import { TaskDataCache } from "../task_data";

const {ccclass, property} = cc._decorator;
//计时任务
@ccclass
export  class TaskTime extends TaskBase {
    @property(TaskTimeItem)
    prefab_item:TaskTimeItem = null

    init(mvvmBase:MVVMBase){
        super.init(mvvmBase,'Toggletimetask','time');
    }

    onActive(finish?:Function){
        this.getData(finish);
    }
    
    protected getData(finish:Function){
        this.refreshAllItem(finish);
    }

    refreshAllItem(finish?:Function){
        let self = this;
        TaskDataCache.instance.getTaskData(self.taskModuleName,(data:any[])=>{
            self.setItemData(data);
            finish && finish();
        },this.mvvmBase,true);
    }

    getPrefab():cc.Node{
        return this.prefab_item.node;
    }
    
    protected update_list_item(itemNode: cc.Node, data: any, index: number){
        itemNode.getComponent(TaskTimeItem).refreshItem(data,this.clickItemFunc.bind(this));
    }
}
